// import PropTypes from 'prop-types';
// import { connect } from 'react-redux';
import HTMLContent from 'components/HtmlContent';
import Layout from 'components/Layout';
import SEO from 'components/seo';
import React from 'react';
import PropTypes from 'prop-types';
import { Row, Table } from 'react-bootstrap';
import { SCol, SContainer } from './styles';

const PrivayPolicy = ({ pageContext }) => {
  return (
    <Layout navType="dark" navBgColor="#fff" navLinkType="dark">
      <SEO
        title="Read our Privacy Policy"
        description="We understand that privacy is important. You can read all of our privacy policies here and get a better understanding of how we are committed to protecting your data"
      />
      {/* <TitleHeader title="Privacy Policy" /> */}

      <SContainer className="my-5">
        <HTMLContent html={pageContext.content} />
      </SContainer>
    </Layout>
  );
};

PrivayPolicy.propTypes = {
  pageContext: PropTypes.string,
};
export default PrivayPolicy;
